import React from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
import { SOCIAL_LINKS } from '@/data/socialLinks';

const ICON_WRAP =
  'inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-gray-300 transition hover:border-teal-400/40 hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-400/70';

const ICON_WRAP_DISABLED =
  'inline-flex h-10 w-10 cursor-not-allowed items-center justify-center rounded-xl border border-white/5 bg-white/[0.03] text-gray-500 opacity-60';

const threadsIconSrc = `${process.env.PUBLIC_URL || ''}/assets/social/threads.svg`;

function SocialAnchor({ href, label, children }) {
  if (!href) {
    return (
      <span
        className={ICON_WRAP_DISABLED}
        title="Link coming soon"
        aria-label={`${label} (link coming soon)`}
      >
        {children}
      </span>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={ICON_WRAP}
      aria-label={label}
    >
      {children}
    </a>
  );
}

/**
 * Compact social icons for the footer (and elsewhere if needed).
 */
export default function SocialMediaLinks({ className = '' }) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`.trim()}>
      <SocialAnchor href={SOCIAL_LINKS.facebook} label="ChooseRightCareer on Facebook">
        <Facebook className="h-5 w-5" strokeWidth={1.75} aria-hidden />
      </SocialAnchor>
      <SocialAnchor href={SOCIAL_LINKS.instagram} label="ChooseRightCareer on Instagram">
        <Instagram className="h-5 w-5" strokeWidth={1.75} aria-hidden />
      </SocialAnchor>
      <SocialAnchor href={SOCIAL_LINKS.threads} label="ChooseRightCareer on Threads">
        <img src={threadsIconSrc} alt="" className="h-[22px] w-[22px] brightness-0 invert opacity-90" />
      </SocialAnchor>
      <SocialAnchor href={SOCIAL_LINKS.linkedin} label="ChooseRightCareer on LinkedIn">
        <Linkedin className="h-5 w-5" strokeWidth={1.75} aria-hidden />
      </SocialAnchor>
    </div>
  );
}
